/** @file Default props to be worked on in isolation when adding to theme, just like MarkdownOrText replacers */
import {
  AnchorProps,
  PortalProps,
  ImageProps,
  TextProps,
  ButtonProps,
  CheckboxProps,
  ScrollAreaProps,
} from '@mantine/core';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import { blackH, primaryColorIndex } from './utils';

export const TextDefaultProps: Partial<TextProps> = {
  color: blackH,
};

export const AnchorDefaultProps: Partial<AnchorProps> = {
  color: primaryColorIndex,
  underline: false,
};
export const PortalDefaultProps: Partial<PortalProps> = {
  target: '#portal',
};
export const ImageDefaultProps: Partial<ImageProps> = {
  radius: 'sm',
  width: 32,
  height: 32,
};

export const ButtonDefaultProps: Partial<ButtonProps> = {
  px: 16,
  py: 10,
};

export const CheckboxDefaultProps: Partial<CheckboxProps> = {
  size: 'xs',
  sx: {
    '.mantine-Checkbox-icon': {
      width: 16,
    },
  },
};

export const ScrollAreaDefaultProps: Partial<ScrollAreaProps> = {
  styles: () => {
    return {
      thumb: {
        '&:hover': {
          backgroundColor: COLORS_FLAT.n400,
        },
        '&': {
          backgroundColor: '#00000026',
        },
      },
    };
  },
  type: 'auto',
};
